module.exports = __webpack_public_path__ + "img/grey.7dad0c90.png";